
export const Theme = {
  container: [
    'px-8 py-6 border-t border-neutral-200',
    'dark:!border-gray-600'
  ]
};
